import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { PoServiceService } from '../../../services/po-service.service';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { DataTableSavedBean } from 'src/app/shared/components/data-table/bean/data-table-saved-bean';
import { AddAdvisingByPurchaseOrderRequest } from 'src/app/core/models/transport-operation/add-po-request';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { deepCopy, isNullOrEmpty, laaSFormatString } from 'src/app/core/utils/common-functions';
import { ToastService } from 'src/app/core/services/toast.service';
import { error } from 'console';

import { LaasOption } from 'src/app/core/models/laas-option';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { GlobalConstants } from 'src/app/core/constants/global-constants.constant';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { FacilityService } from 'src/app/core/services/facility.service';
import { isDetailIssuable } from 'src/app/shared/pipes/detail-issuable.pipe';

@Component({
  selector: 'laas-po-convert-ad',
  templateUrl: './po-convert-ad.component.html',
  styleUrls: ['./po-convert-ad.component.scss'],
})
export class PoConvertAdComponent extends SessionBaseComponent implements OnInit
{
  @ViewChild('createAdTable') createAdTable!: DataTableComponent;
  readonly editPermissionCode: PermissionConstants = PermissionConstants.ConvertPoToAd;
  readonly preferenceKey: string = UserPreferenceConstants.PurchaseSearchCreateAd;
  isDetailLoading: boolean = false;
  isCreateLoading: boolean = false;
  isShowPoCreateAdForm: boolean = true;
  isShowAsnCreateAdForm: boolean = false;
  isInputDefaultOpenQty: boolean = true;
  isShowDetailTable: boolean = false;
  isShowSuccessfulAdNo: boolean = false;
  editPermission: boolean = false;
  poDetailColumns: any[];
  asnDetailColumns: any[];
  dnDetailColumns: any[];
  detailColumns: any[] = [];
  createDocOptions: any[] = [];
  submitted: boolean = false;
  shipMethodOptions: any[] = [];
  textColor: string = '#58595b';
  customerImportNoTextColor: string = '#58595b';

  createDoc: any;
  poNo: string = '';
  onlyAsnFlag: string = '';
  vendorNo: string = '';
  vendorName: string = '';
  successfulAdNo: string = "";
  preCreateDoc: any;

  headerDatas: any[] = [];
  detailDatas: any[] = [];

  createAdHeaderForm: FormGroup;
  createDocForm: FormGroup;
  addAdvisingByPurchaseOrderRequest: AddAdvisingByPurchaseOrderRequest;

  declTypeOptions: LaasOption[] = [];
  countryOptions: LaasOption[] = [];

  bondedSpecLocTypeList: any[] = [];

  constructor(
    injector: Injector,
    private poServiceService: PoServiceService,
    private formBuilder: FormBuilder,
    private commonDataService: CommonDataService,
    private facilityService: FacilityService,
  ) {
    super(injector);

    this.addAdvisingByPurchaseOrderRequest = {
      poNo: null,
      priority: null,
      onlyAsnFlag: null,
      billOfLading: null,
      inbondedFlag: null,
      customerImportNo: null,
      type: null,
      warehouse: null,
      vendorNo: null,
      vendorName: null,
      createUser: null,
      createUserUUID: null,
      createDt: undefined,
      facility: null,
      asnNo: null,
      dnNo: null,
      methodFlag: null,
      addBBPAdvisingDetailData: null,
      declType: null,
      refBillNo: null,
      gdsType: null,
      shippingMethod: null
    };

    this.createAdHeaderForm = this.formBuilder.group({
      billOfLading: '',
      inbondedFlag: '',
      shippingMethod: ['', Validators.required],
      customerImportNo: ['', [this.checkStringLength]],
      priority: false,
      declType: '',
      refBillNo: '',
      gdsType: ''
    });

    this.createDocForm = this.formBuilder.group({
      createDoc: null
    })

    this.poDetailColumns = [
      { field: '__Function', header: 'PurchaseOrder.DetailColumn.Function', sort: true},
      { field: 'poNo', header: 'PurchaseOrder.DetailColumn.PoNo', sort: true},
      { field: 'sku', header: 'PurchaseOrder.DetailColumn.Sku', sort: true},
      { field: 'shortageQty', header: 'AsnDn.DetailColumn.ShortageQty', sort: true},
      { field: 'openQty', header: 'PurchaseOrder.DetailColumn.OpenQty', sort: true},
      { field: 'location', header: 'PurchaseOrder.DetailColumn.Location', sort: true },
      { field: 'itemNo', header: 'PurchaseOrder.DetailColumn.ItemNo', sort: true},
      { field: 'coo', header: 'PurchaseOrder.DetailColumn.COO', sort: true},
      { field: 'poLineNumber', header: 'PurchaseOrder.DetailColumn.PoLineNumber', sort: true},
      { field: 'poType', header: 'PurchaseOrder.DetailColumn.PoType', sort: true},
      { field: 'brand', header: 'PurchaseOrder.DetailColumn.Brand', sort: true},
      { field: 'manufacturerPartNumber', header: 'PurchaseOrder.DetailColumn.ManufacturerPartNumber', sort: true},
      { field: 'aliveStatus', header: 'AsnDn.DetailColumn.AliveStatus', sort: true },
      { field: 'autoAdvisingFlag', header: 'AsnDn.DetailColumn.AutoAdvising', sort: true },
      { field: '__delete', header: 'PurchaseOrder.DetailColumn.Delete', sort: false }
    ];

    this.asnDetailColumns = [
      { field: '__Function', header: 'AsnDn.DetailColumn.Function', sort: true},
      { field: 'poNo', header: 'AsnDn.DetailColumn.PoNo', sort: true},
      { field: 'sku', header: 'AsnDn.DetailColumn.Sku', sort: true},
      { field: 'shortageQty', header: 'AsnDn.DetailColumn.ShortageQty', sort: true},
      { field: 'openQty', header: 'AsnDn.DetailColumn.OpenQty', sort: true},
      { field: 'location', header: 'AsnDn.DetailColumn.Location', sort: true },
      { field: 'isBackflush', header: 'AsnDn.DetailColumn.IsBackflush', sort: true },
      { field: 'brand', header: 'AsnDn.DetailColumn.Brand', sort: true},
      { field: 'itemNo', header: 'AsnDn.DetailColumn.ItemNo', sort: true},
      { field: 'coo', header: 'AsnDn.DetailColumn.COO', sort: true},
      { field: 'asnLineNo', header: 'AsnDn.DetailColumn.AsnLineNo', sort: true },
      { field: 'poLineNumber', header: 'AsnDn.DetailColumn.PoLineNumber', sort: true},
      { field: 'poType', header: 'AsnDn.DetailColumn.PoType', sort: true},
      { field: 'manufacturerPartNumber', header: 'AsnDn.DetailColumn.ManufacturerPartNumber', sort: true},
      { field: 'isBonded', header: 'AsnDn.DetailColumn.IsBonded', sort: true },
      { field: 'skuDesc', header: 'AsnDn.DetailColumn.SkuDesc', sort: true },
      { field: 'stsFlag', header: 'AsnDn.DetailColumn.StsFlag', sort: true },
      { field: 'aliveStatus', header: 'AsnDn.DetailColumn.AliveStatus', sort: true },
      { field: 'autoAdvisingFlag', header: 'AsnDn.DetailColumn.AutoAdvising', sort: true },
      { field: '__delete', header: 'AsnDn.DetailColumn.Delete', sort: false }
    ];

    this.dnDetailColumns = [
      { field: '__Function', header: 'AsnDn.DetailColumn.Function', sort: true},
      { field: 'poNo', header: 'AsnDn.DetailColumn.PoNo', sort: true},
      { field: 'sku', header: 'AsnDn.DetailColumn.Sku', sort: true},
      { field: 'shortageQty', header: 'AsnDn.DetailColumn.ShortageQty', sort: true},
      { field: 'openQty', header: 'AsnDn.DetailColumn.OpenQty', sort: true},
      { field: 'location', header: 'AsnDn.DetailColumn.Location', sort: true },
      { field: 'isBackflush', header: 'AsnDn.DetailColumn.IsBackflush', sort: true },
      { field: 'brand', header: 'AsnDn.DetailColumn.Brand', sort: true},
      { field: 'itemNo', header: 'AsnDn.DetailColumn.ItemNo', sort: true},
      { field: 'coo', header: 'AsnDn.DetailColumn.COO', sort: true},
      { field: 'dnLineNo', header: 'AsnDn.DetailColumn.DnLineNo', sort: true },
      { field: 'poLineNumber', header: 'AsnDn.DetailColumn.PoLineNumber', sort: true},
      { field: 'poType', header: 'AsnDn.DetailColumn.PoType', sort: true},
      { field: 'manufacturerPartNumber', header: 'AsnDn.DetailColumn.ManufacturerPartNumber', sort: true},
      { field: 'isBonded', header: 'AsnDn.DetailColumn.IsBonded', sort: true },
      { field: 'skuDesc', header: 'AsnDn.DetailColumn.SkuDesc', sort: true },
      { field: 'stsFlag', header: 'AsnDn.DetailColumn.StsFlag', sort: true },
      { field: 'aliveStatus', header: 'AsnDn.DetailColumn.AliveStatus', sort: true },
      { field: 'autoAdvisingFlag', header: 'AsnDn.DetailColumn.AutoAdvising', sort: true },
      { field: '__delete', header: 'AsnDn.DetailColumn.Delete', sort: false }
    ];

    commonDataService.getAppCsmSetting('FacilityBondedSpecLocType')
      .subscribe({
        next:(option:any)=>{
          this.bondedSpecLocTypeList = [...option.appCsmSettingDetailList].map(x => x.setupValue);
        }
      }
    );
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.poNo = this.routeStateService.getCurrent().data.poHeader.poNo;
    this.onlyAsnFlag = this.routeStateService.getCurrent().data.poHeader.onlyAsnFlag;
    this.vendorNo = this.routeStateService.getCurrent().data.poHeader.vendorNo;
    this.vendorName = this.routeStateService.getCurrent().data.poHeader.vendorName;
    this.createDocOptions = []; //在這裡初始化一次，不然會出現field無法顯示selected的item

    //找此張Po的所有Asn跟Dn
    this.poServiceService.searchAsnNoByPoNo(this.poNo).subscribe({
      next: (result) => {
        result.forEach((value: any) => {
          this.createDocOptions.push({
            label: value,
            value: {
              docType: 'asn',
              docNo: value,
            },
          });
        });
      },
    });
    this.poServiceService.searchDnNoByPoNo(this.poNo).subscribe({
      next: (result) => {
        result.forEach((value: any) => {
          this.createDocOptions.push({
            label: value,
            value: {
              docType: 'dn',
              docNo: value,
            },
          });
        });
      },
    });
    //加入po選項
    //如果onlyAsnFlag=Y代表此單不能由PO建立
    if (this.onlyAsnFlag == 'Y') {
      this.createDocOptions.unshift({
        label: 'Create By Po',
        value: { docType: 'po', docNo: this.poNo },
        disabled: true,
      });
    } else {
      this.createDocOptions.unshift({
        label: 'Create By Po',
        value: { docType: 'po', docNo: this.poNo },
      });
    }

    if (this.userProfile && this.userProfile.roles) {
      const permssionCodes = (Object.values(this.userProfile.roles)
        .reduce((c: any, i: any) => c.concat(i.permissions), []) as any).map((x: any) => {
          return x.permissionCode;
        });

      if (permssionCodes.includes(this.editPermissionCode)) {
        this.editPermission = true;
      }
    }

    this.poServiceService.getMappingDeclTypeOptions().subscribe({
      next: (result) =>{
        this.declTypeOptions = result.map((x: { optionDesc: any; optionCode: any; }) => ({
          label: x.optionDesc,
          value: x.optionCode
        }));
      }
    })

    this.commonDataService.getCountry().subscribe({
      next: (response) => {
        for (const country of response) {
          if (this.laasSetting.language == GlobalConstants.defaultLanguage) {
            this.countryOptions.push({
              label: `${country.countryCodeISO} - ${country.countryName}`,
              value: country.countryCodeISO
            })
          }
          else {
            this.countryOptions.push({
              label: `${country.countryCodeISO} - ${country.countryEnName}`,
              value: country.countryCodeISO
            })
          }
        }
      }

    })

    // 運送方式
    this.facilityService.getShipMethodOptions().subscribe({
      next: result => {
        this.shipMethodOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.createAdHeaderForm.get('inbondedFlag')?.valueChanges.subscribe((value) => {
      const declTypeControl = this.createAdHeaderForm.get('declType');
      const gdsTypeControl = this.createAdHeaderForm.get('gdsType');
      if(value === "NonBonded"){
        this.createAdHeaderForm.controls['declType'].setValue('');
        this.createAdHeaderForm.controls['gdsType'].setValue('');
        declTypeControl?.disable();
        gdsTypeControl?.disable();
        this.textColor = '#BABABB';
      }else{
        declTypeControl?.enable();
        gdsTypeControl?.enable();
        this.textColor = '#58595b';
      }
    });

    this.createAdHeaderForm.get('gdsType')?.valueChanges.subscribe((value) => {
      if(value === "aTransaction"){
        this.toastService.info(
          this.translateService.instant('PurchaseOrder.CreateAd.Message.RemindByTransactionRequiredFields')
        );
      }
    });

    this.createAdHeaderForm.get('shippingMethod')?.valueChanges.subscribe((value) => {
      const customerImportNoControl = this.createAdHeaderForm.get('customerImportNo');
      if(value === "3"){
        customerImportNoControl?.disable();
        this.createAdHeaderForm.controls['customerImportNo'].setValue('');
        this.customerImportNoTextColor = '#BABABB';
      }else{
        customerImportNoControl?.enable();
        this.customerImportNoTextColor = '#58595b';
      }
    });

  }

  chooseCreateDoc() {

    //切換單據時需退出編輯模式
    if (this.createAdTable.isInEditMode) {
      this.createDoc = this.preCreateDoc;
      this.createDocForm.controls["createDoc"].setValue(this.preCreateDoc);
      this.toastService.warn(
        this.translateService.instant('PurchaseOrder.CreateAd.Message.ExitEdit')
      );
    } else{
      this.changeCreateDoc();
    }
    console.log('changeCreateDoc',this.createDoc)
  }

  changeCreateDoc(){
    this.preCreateDoc = this.createDoc;
    if (this.createDoc.docType == 'po') {
      this.detailColumns = this.poDetailColumns;
      this.searchPoByPoNo();
    } else if (this.createDoc.docType == 'asn') {
      this.detailColumns = this.asnDetailColumns;
      this.searchAsnByAsnNo();
    } else if (this.createDoc.docType == 'dn') {
      this.detailColumns = this.dnDetailColumns;
      this.searchDnByDnNo();
    }
    this.createAdTable.selectedCols = this.detailColumns;
  }

  searchPoByPoNo() {
    this.isDetailLoading = true;
    this.poServiceService.searchPoByPoNo(this.createDoc.docNo).subscribe({
      next: (result) => {
        this.copyPoHeaderToAddAdHeaderRequest(result);
        this.detailDatas = result.purchaseOrderDetailForCreateAdBeanList;
        this.detailDatas.forEach((x) => {
          x.cloneOpenQty = x.openQty;
          x.poType = result.poType;
        });
      },
      complete: () => {
        this.isDetailLoading = false;
      },
    });
  }

  searchAsnByAsnNo() {
    this.isDetailLoading = true;
    this.poServiceService.searchAsnByAsnNo(this.createDoc.docNo).subscribe({
      next: (result) => {
        this.copyAsnHeaderToAddAdHeaderRequest(result);
        this.detailDatas = result.detailBeanList;
        this.detailDatas.forEach((x) => {
          x.cloneOpenQty = x.openQty;
        });
      },
      complete: () => {
        this.isDetailLoading = false;
      },
    });
  }

  searchDnByDnNo() {
    this.isDetailLoading = true;
    this.poServiceService.searchDnByDnNo(this.createDoc.docNo).subscribe({
      next: (result) => {
        this.copyDnHeaderToAddAdHeaderRequest(result);
        this.detailDatas = result.detailBeanList;
        this.detailDatas.forEach((x) => {
          x.cloneOpenQty = x.openQty;
        });
      },
      complete: () => {
        this.isDetailLoading = false;
      },
    });
  }

  inputDefaultOpenQty() {
    if (this.isInputDefaultOpenQty) {
      this.detailDatas.filter((x) => this.isIssuable(x)).forEach((x) => {
        if (x.cloneOpenQty !== undefined) {
          x.openQty = x.cloneOpenQty;
        }
      });
    } else {
      this.detailDatas.forEach((x) => {
        x.openQty = null;
      });
    }
    this.createAdTable.value = this.detailDatas;
    this.createAdTable.initSetupValue();
  }

  async createAd() {
    this.isCreateLoading = true;
    if (!(await this.checkDataInputValid()) || !this.checkDetailDataInputValid() || !this.checkItemNo()) {
      this.isCreateLoading = false;
      return;
    }

    this.convertHeaderFormToAddAdHeaderRequest();

    this.addAdvisingByPurchaseOrderRequest.addBBPAdvisingDetailData =
    this.detailDatas
      .filter((item) => item.openQty !== 0 && !isNullOrEmpty(item.openQty) && this.isIssuable(item))
      .map(({ cloneOpenQty, autoAdvisingFlag, ...finalDetailDatas }) => finalDetailDatas);
    this.addAdvisingByPurchaseOrderRequest.createUserUUID = this.userProfile.uuid;
    this.addAdvisingByPurchaseOrderRequest.createDt = new Date();

    console.log('createAd detailDatas',this.detailDatas,'\createAd Request',this.addAdvisingByPurchaseOrderRequest);
    this.poServiceService
      .createAd(this.addAdvisingByPurchaseOrderRequest)
      .subscribe({
        next: (response) => {
          this.successfulAdNo = response.adNoList;
          this.isShowSuccessfulAdNo = true;
        },
        error: (err:any) =>{
          this.toastErrorMessage(err.error);
          this.isCreateLoading = false;
        },
        complete:()=>{
          this.isCreateLoading = false;
        }
      });
  }

  async checkDataInputValid(): Promise<boolean> {

    if(isNullOrEmpty(this.createDoc) || this.createDoc.docType == null){
      this.toastService.warn("Please choose Doc Number to create.");
      return false;
    }

    //保稅要檢查是不是放在保稅的儲區別
    if (this.createAdHeaderForm.controls['inbondedFlag'].value === "InBonded") {
      const notBondedSkuList: string[] = [];
      // 只檢查可開單的資料
      this.detailDatas.filter(detailData => this.isIssuable(detailData)).forEach(detailData => {
        if (!this.bondedSpecLocTypeList.includes(detailData.location)) {
          notBondedSkuList.push(detailData.sku);
        }
      });

      if (notBondedSkuList.length > 0) {
        const instantMsg = await this.translateService.get('PurchaseOrder.CreateAd.Message.CheckSkuMustBeBondedLocation').toPromise();
        const abnormalSkuList = notBondedSkuList.join("\n");
        const msg = `${laaSFormatString(instantMsg, [abnormalSkuList])}\n`;
        this.toastService.warn(msg);
        return false;
      }

    }

    const rules = [
      {
        //稅務類型、運送方式為必填
        condition: () => isNullOrEmpty(this.createAdHeaderForm.controls['inbondedFlag'].value) || isNullOrEmpty(this.createAdHeaderForm.controls['shippingMethod'].value),
        messageKey: 'PurchaseOrder.CreateAd.Message.CheckRequiredFields'
      },
      {
        //以Asn/Dn單建立的話每條數量為必填
        condition: () => this.createDoc.docType !== 'po' && this.detailDatas.some(x => this.isIssuable(x) && isNullOrEmpty(x.openQty)),
        messageKey: 'Common.Toast.CheckRequiredFields'
      },
      {
        //只能輸入正整數
        condition: () => this.detailDatas.some(x => this.isIssuable(x) && !isNullOrEmpty(x.openQty) && (x.openQty < 0 || !Number.isInteger(x.openQty))),
        messageKey: 'PurchaseOrder.CreateAd.Message.EnterInterger'
      },
      {
        condition: () => this.createAdHeaderForm.controls['customerImportNo'].value.length > 20,
        messageKey: 'PurchaseOrder.CreateAd.Message.ImportNoOversize'
      },
      {
        //如果是保稅 declType、gdsType必填
        condition: () => this.createAdHeaderForm.controls['inbondedFlag'].value === "InBonded" &&
                       (isNullOrEmpty(this.createAdHeaderForm.controls['declType'].value) || isNullOrEmpty(this.createAdHeaderForm.controls['gdsType'].value)),
        messageKey: 'PurchaseOrder.CreateAd.Message.CheckInbondedRequiredFields'
      },
      {
        //如果是逐筆申報 報單號碼refBillNo必填
        condition: () => this.createAdHeaderForm.controls['gdsType'].value === "aTransaction" && isNullOrEmpty(this.createAdHeaderForm.controls['refBillNo'].value),
        messageKey: 'PurchaseOrder.CreateAd.Message.CheckByTransactionRequiredFields'
      },
      {
        //如果運送方式非陸運，ImportNo 必填
        condition: () => this.createAdHeaderForm.controls['shippingMethod'].value !== "3" &&
                       isNullOrEmpty(this.createAdHeaderForm.controls['customerImportNo'].value),
        messageKey: 'PurchaseOrder.CreateAd.Message.CheckBImportNo'
      }
    ];

    for (const rule of rules) {
      if (rule.condition()) {
          this.toastService.warn(this.translateService.instant(rule.messageKey));
        return false;
      }
    }

    return true;
  }

  checkDetailDataInputValid(): boolean {
    //如果是逐筆申報 報單項次、報關產地 都必填
    if (this.createAdHeaderForm.controls['gdsType'].value === "aTransaction") {
      for (const item of this.detailDatas) {
        if (this.isIssuable(item) && (isNullOrEmpty(item.itemNo) || isNullOrEmpty(item.coo))) {
          this.toastService.warn(
            this.translateService.instant('PurchaseOrder.CreateAd.Message.CheckByTransactionDetailRequiredFields')
          );
          return false;
        }
      }
    }
    return true;
  }

  checkItemNo() {
    for (const item of this.detailDatas) {
      //ItemNo 的值只能是數字
      const isNumFlag = (isNaN(Number(item.itemNo)) && (item.itemNo) !== '' && (item.itemNo) !== undefined);
      if (isNumFlag) {
        this.toastService.warn(
          this.translateService.instant('PurchaseOrder.CreateAd.Message.ItemNoIsNumber')
        );
        return false;
      }
    }

    // =========== 確認 ItemNo 的值是唯一 ================
    const itemNos = this.detailDatas.map(data => data.itemNo);
    console.log("itemNos = " + JSON.stringify(itemNos));

    //去除itemNos空值
    for (let i = 0; i < itemNos.length; i++) {
      if (itemNos[i] === '' || itemNos[i] === undefined || itemNos[i] === null) {
        itemNos.splice(i, 1);
        i--;
      }
    }

    const uniqueItemNos = new Set(itemNos); //用Set去除重複值

    //去除uniqueItemNos空值
    uniqueItemNos.forEach((itemNo, index) => {
      if (itemNo === '' || itemNo === undefined || itemNo === null) {
        uniqueItemNos.delete(itemNo);
      }
    });

    const isUniqFlag = (uniqueItemNos.size === itemNos.length);

    if (!isUniqFlag) {
      this.toastService.warn(
        this.translateService.instant('PurchaseOrder.CreateAd.Message.ItemNoIsUniq')
      );
      return false;
    }

    return true;
  }

  copyPoHeaderToAddAdHeaderRequest(headerResult: any) {
    this.addAdvisingByPurchaseOrderRequest.poNo = headerResult.poNo;
    this.addAdvisingByPurchaseOrderRequest.type = headerResult.poType;
    this.addAdvisingByPurchaseOrderRequest.warehouse = headerResult.warehouse;
    this.addAdvisingByPurchaseOrderRequest.methodFlag = 'P';
  }

  copyAsnHeaderToAddAdHeaderRequest(headerResult: any) {
    this.addAdvisingByPurchaseOrderRequest.asnNo = headerResult.asnNo;
    this.addAdvisingByPurchaseOrderRequest.warehouse = headerResult.warehouse;
    this.addAdvisingByPurchaseOrderRequest.methodFlag = 'A';
  }

  copyDnHeaderToAddAdHeaderRequest(headerResult: any) {
    this.addAdvisingByPurchaseOrderRequest.dnNo = headerResult.dnNo;
    this.addAdvisingByPurchaseOrderRequest.warehouse = headerResult.warehouse;
    this.addAdvisingByPurchaseOrderRequest.methodFlag = 'DN';
  }

  convertHeaderFormToAddAdHeaderRequest() {
    this.addAdvisingByPurchaseOrderRequest.vendorNo = this.vendorNo;
    this.addAdvisingByPurchaseOrderRequest.vendorName = this.vendorName;
    this.addAdvisingByPurchaseOrderRequest.onlyAsnFlag = this.onlyAsnFlag;
    this.addAdvisingByPurchaseOrderRequest.billOfLading = isNullOrEmpty(this.createAdHeaderForm.controls['billOfLading'].value)?
        null:this.createAdHeaderForm.controls['billOfLading'].value;
    this.addAdvisingByPurchaseOrderRequest.customerImportNo = isNullOrEmpty(this.createAdHeaderForm.controls['customerImportNo'].value)?
        null:this.createAdHeaderForm.controls['customerImportNo'].value;
    if (this.createAdHeaderForm.controls['inbondedFlag'].value) {
      this.addAdvisingByPurchaseOrderRequest.inbondedFlag = 'Y';
    } else {
      this.addAdvisingByPurchaseOrderRequest.inbondedFlag = 'N';
    }
    if (this.createAdHeaderForm.controls['priority'].value) {
      this.addAdvisingByPurchaseOrderRequest.priority = '1';
    } else {
      this.addAdvisingByPurchaseOrderRequest.priority = '5';
    }

    this.addAdvisingByPurchaseOrderRequest.declType = isNullOrEmpty(this.createAdHeaderForm.controls['declType'].value)?
    null:this.createAdHeaderForm.controls['declType'].value;
    switch (this.createAdHeaderForm.controls['gdsType'].value) {
      case "monthly":
        this.addAdvisingByPurchaseOrderRequest.gdsType = "M";
        break;
      case "aTransaction":
        this.addAdvisingByPurchaseOrderRequest.gdsType = this.createAdHeaderForm.controls['declType'].value;
        break;
    }
    this.addAdvisingByPurchaseOrderRequest.refBillNo = isNullOrEmpty(this.createAdHeaderForm.controls['refBillNo'].value)?
    null:this.createAdHeaderForm.controls['refBillNo'].value;
    this.addAdvisingByPurchaseOrderRequest.shippingMethod = isNullOrEmpty(this.createAdHeaderForm.controls['shippingMethod'].value)?
    null:this.createAdHeaderForm.controls['shippingMethod'].value;

    //----ImportNo 值的設定----
    //陸運 + 保稅 + 按月匯報 -> ImportNo disable，ImportNo= LaaS_B
    if (this.createAdHeaderForm.controls['shippingMethod'].value === "3" &&
      this.createAdHeaderForm.controls['inbondedFlag'].value === "InBonded" &&
      this.createAdHeaderForm.controls['gdsType'].value === "monthly"
    ) {
      this.addAdvisingByPurchaseOrderRequest.customerImportNo = 'LaaS_B';

    //陸運 + 非保稅 ->  ImportNo disable，ImportNo= LaaS_N
    } else if (this.createAdHeaderForm.controls['shippingMethod'].value === "3" &&
      this.createAdHeaderForm.controls['inbondedFlag'].value === "NonBonded"
    ){
      this.addAdvisingByPurchaseOrderRequest.customerImportNo = 'LaaS_N';

    //陸運 + 保稅 + 逐筆 ->   ImportNo disable，不用值，放null
    }else if (this.createAdHeaderForm.controls['shippingMethod'].value === "3" &&
      this.createAdHeaderForm.controls['inbondedFlag'].value === "InBonded" &&
      this.createAdHeaderForm.controls['gdsType'].value === "aTransaction"
    ){
      this.addAdvisingByPurchaseOrderRequest.customerImportNo = null;
    }
    //其他 = ImportNo本身欄位值
    else{
      this.addAdvisingByPurchaseOrderRequest.customerImportNo = this.createAdHeaderForm.controls['customerImportNo'].value;
    }
  }

  /**
   * 此明細是否可人工開立進貨單。判定規則與範本用的 detailIssuable 管線同一份實作,
   * 送出、檢核與畫面反灰才不會出現其中一處放行、另一處擋下的情形。
   * Whether the detail may be issued manually; shares one implementation with the template pipe so
   * submission, validation and greying out can never disagree.
   */
  isIssuable(rowData: { aliveStatus?: string; autoAdvisingFlag?: string }): boolean {
    return isDetailIssuable(rowData);
  }

  checkStringLength(control:any) {
    if (control.value && control.value.length > 20) {
      return { 'maxlength': true };
    }
    return null;
  }

  checkNumberInteger(openQty:number){
    //ASN/DN為必填且只能輸入正整數
    if (this.createDoc.docType != 'po' && (openQty == null || openQty == undefined || openQty < 0 || !Number.isInteger(openQty))){
      return false;
    }
    //PO不為必填 但只能輸入正整數
    if(this.createDoc.docType == 'po' && (openQty != null || openQty != undefined) && (!Number.isInteger(openQty) || openQty < 0)){
      return false;
    }
    return true;
  }

  copyBtnClick($event: MouseEvent, rowData: any) {

    const index = this.detailDatas.indexOf(rowData);
    const newRow = { ...rowData };
    newRow.seqNo = Math.max(...this.detailDatas.map(item => item.seqNo)) + 1;
    newRow.itemNo = null;
    newRow.coo = null;
    // 在該列的下一列插入複製的資料
    this.detailDatas.splice(index + 1, 0, newRow);
    this.createAdTable.value = this.detailDatas;
  }

  InputItemNo() {
    if (this.createDoc.docType == 'po') {
      this.detailDatas.forEach(item => {
        item.itemNo = item.poLineNumber + "";
      });
    } else if (this.createDoc.docType == 'asn') {
      this.detailDatas.forEach(item => {
        item.itemNo = item.asnLineNo + "";
      });
    } else if (this.createDoc.docType == 'dn') {
      this.detailDatas.forEach(item => {
        item.itemNo = item.dnLineNo + "";
      });
    }
    this.createAdTable.value = this.detailDatas;
  }


  deleteBtnClick(seqNo:any){
    this.detailDatas = this.detailDatas.filter(item => item.seqNo !== seqNo);
    this.createAdTable.value = this.detailDatas;
    this.createAdTable.initSetupValue();
  }

}
